import { AppBaseProps, CommonApp, Entity } from "../core/components/commonApp.js";
import { NukreisEntity } from "./nukreis.js";
import { AppHelper } from "../appHelper.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { Helper } from "../core/util/helper.js";
import { DialogHelper } from "../core/util/dialogHelper.js";
import { StringKeyDictionary } from "../commonInterfaces.js";
import React from "react";

export default class NuKreisId extends React.Component<NuKreisIdProps, any>{
    common = new AppHelper();
    constructor(props) {
        super(props);
        this.common.init(this);
        this.state = {}
    }

    private checkForRangeOverlaps = () => {
        return new Promise<boolean>(async (resolve) => {
            const doOverlaps = (rangeA: { min: number; max: number }, rangeB: { min: number; max: number }) => {
                const con1 = (rangeA.min <= rangeB.min) && (rangeB.min <= rangeA.max);
                const con2 = (rangeA.min <= rangeB.max) && (rangeB.max <= rangeA.max);
                return con1 || con2;
            }
            let data = this.props.entity.Data.filter(x => Helper.hasValue(x.MaxNr) && Helper.isNumber(x.MaxNr) && Helper.hasValue(x.MinNr) && Helper.isNumber(x.MinNr));
            let overlapOccured = false;
            for (let i = 0; i < data.length; i++) {
                for (let j = (data.length - 1); j > i; j--) {
                    overlapOccured = doOverlaps({ min: data[i].MinNr, max: data[i].MaxNr }, { min: data[j].MinNr, max: data[j].MaxNr });
                    if (overlapOccured) {
                        break;
                    }
                }
                if (overlapOccured) {
                    break;
                }
            }
            if (!overlapOccured) {
                resolve(true);
            } else {
                const isOK = await DialogHelper.confirm(this.props.translations["WebCRM.Nukreis.OverlapsOccured"])
                resolve(isOK);
            }
        })
    }

    handleFieldChange = (field: { model: string }, value, dataItem = null, isInit = false) => {
        switch (field.model) {
            default:
                break;
        }

        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    save = async () => {
        const isValid: boolean = await this.checkForRangeOverlaps();// && this.common.validate();
        if (isValid) {
            const result = await HTTPService.post<JsonResultClass>("Nukreis/SaveNuKreisIdList", { models: this.props.entity.Data, type: this.props.entity.Type });
            switch (result.Code) {
                case 0:
                    NotificationHelper.showSuccessMessage(result.Message);
                    break;
                case 1:
                    NotificationHelper.showErrorMessage(result.Message);
                    break;
            }
            this.common.handlePostSave(result.Code === 0, false);
        }
    }

    componentDidMount() {
        this.common.updateSheetTitle(this.props.title);
        this.common.updateBrowserTitle(this.props.title);
    }


    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} title={this.props.title} />;
    }
}

export interface NuKreisIdProps extends AppBaseProps {
    translations: StringKeyDictionary<string>;
    entity: NuKreisIdListEntity;
}

export interface NuKreisIdListEntity extends Entity {
    Type: string;
    Data: NukreisIdEntity[];
}

export interface NukreisIdEntity extends NukreisEntity {
    MainGroupId: number;
    MainGroup: string;
}